import mixpanel from 'mixpanel-browser';
import { storeToRefs } from 'pinia';
import { useUserDetailsStore } from '@/stores/useUserDetails';

export function useMixpanelTrack(event, properties) {
  const userDetailsStore = useUserDetailsStore();
  const { carrierID, userID } = storeToRefs(userDetailsStore);

  mixpanel.track(event, {
    carrier_id: carrierID.value,
    user_id: userID.value,
    distinct_id: userID.value,
    ...properties,
  });
}
